export const COLOR_AZUL_MAIN = '#000D39';